query getChannelActiveStatuses($channelIds: [ID!]!) {
    channelActiveStatuses(channelIds: $channelIds)
}
